export const CookiesSection3 = () => {
  return (
    <>
      <section id="cookie-control">
        <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. How to Control Cookies</h2>
        <div className="space-y-4 text-base leading-relaxed text-gray-700">
          <p>You have the right to decide whether to accept or reject cookies.</p>

          <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">5.1 Browser Settings</h3>
          <p>Most web browsers allow you to control cookies through their settings. You can:</p>
          <ul className="ml-6 space-y-2 list-disc">
            <li>View and delete cookies currently stored on your device</li>
            <li>Block all cookies from all websites</li>
            <li>Block cookies from specific websites</li>
            <li>Block third-party cookies</li>
            <li>Delete all cookies when you close your browser</li>
            <li>Receive a notification before a cookie is stored</li>
          </ul>

          <p className="mt-4">
            Here are links to cookie management instructions for popular browsers:
          </p>
          <ul className="ml-6 space-y-2 list-disc">
            <li>
              <a
                href="https://support.google.com/chrome/answer/95647"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 underline hover:text-blue-800"
              >
                Google Chrome
              </a>
            </li>
            <li>
              <a
                href="https://support.mozilla.org/en-US/kb/enhanced-tracking-protection-firefox-desktop"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 underline hover:text-blue-800"
              >
                Mozilla Firefox
              </a>
            </li>
            <li>
              <a
                href="https://support.apple.com/guide/safari/manage-cookies-sfri11471/mac"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 underline hover:text-blue-800"
              >
                Apple Safari
              </a>
            </li>
            <li>
              <a
                href="https://support.microsoft.com/en-us/microsoft-edge/delete-cookies-in-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 underline hover:text-blue-800"
              >
                Microsoft Edge
              </a>
            </li>
          </ul>

          <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">5.2 Opt-Out Tools</h3>
          <p>You can also opt out of specific types of tracking:</p>
          <ul className="ml-6 space-y-2 list-disc">
            <li>
              <strong>Google Analytics Opt-Out:</strong>{' '}
              <a
                href="https://tools.google.com/dlpage/gaoptout"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 underline hover:text-blue-800"
              >
                Browser Add-on
              </a>
            </li>
            <li>
              <strong>Facebook Advertising Opt-Out:</strong>{' '}
              <a
                href="https://www.facebook.com/ads/preferences"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 underline hover:text-blue-800"
              >
                Ad Preferences
              </a>
            </li>
            <li>
              <strong>General Advertising Opt-Out:</strong>{' '}
              <a
                href="https://optout.aboutads.info/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 underline hover:text-blue-800"
              >
                Digital Advertising Alliance
              </a>
            </li>
          </ul>

          <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">
            5.3 Impact of Disabling Cookies
          </h3>
          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-6">
            <p className="font-semibold text-gray-900 mb-2">IMPORTANT:</p>
            <p className="text-gray-700">
              If you disable or reject cookies, some features of our Service may not function
              properly. Specifically:
            </p>
            <ul className="ml-6 mt-2 space-y-1 list-disc text-gray-700">
              <li>You may not be able to sign in or stay signed in</li>
              <li>Your preferences and settings may not be saved</li>
              <li>Some features requiring authentication may be unavailable</li>
              <li>Integration with Facebook, Instagram, and WhatsApp may not work</li>
            </ul>
          </div>

          <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">
            5.4 Do Not Track Signals
          </h3>
          <p>
            Some browsers support &quot;Do Not Track&quot; (DNT) signals. Currently, there is no
            industry standard for how websites should respond to DNT signals. Our Service does not
            respond to DNT signals at this time.
          </p>
        </div>
      </section>

      <section id="updates">
        <h2 className="text-2xl font-semibold text-gray-900 mb-4">
          6. Updates to This Cookies Policy
        </h2>
        <div className="space-y-4 text-base leading-relaxed text-gray-700">
          <p>
            We may update this Cookies Policy from time to time to reflect changes in our practices,
            technologies, legal requirements, or other factors.
          </p>
          <p>
            When we make changes, we will update the &quot;Last updated&quot; date at the top of
            this policy. We may also notify you of significant changes by:
          </p>
          <ul className="ml-6 space-y-2 list-disc">
            <li>Posting a notice on our website</li>
            <li>Sending an email to the address associated with your account</li>
            <li>Displaying a notification when you log in to the Service</li>
          </ul>
          <p>
            We encourage you to review this Cookies Policy periodically to stay informed about how
            we use cookies.
          </p>
        </div>
      </section>

      <section id="contact">
        <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. Contact Information</h2>
        <div className="space-y-4 text-base leading-relaxed text-gray-700">
          <p>
            If you have any questions about our use of cookies or this Cookies Policy, please
            contact us:
          </p>
          <div className="bg-gray-50 border border-gray-200 rounded-lg p-6">
            <p className="font-semibold text-gray-900 mb-2">WinGrow</p>
            <p className="text-gray-700">
              Email:{' '}
              <a
                href="mailto:viprielt24@gmail.com"
                className="text-blue-600 underline hover:text-blue-800"
              >
                viprielt24@gmail.com
              </a>
            </p>
            <p className="text-gray-700">Website: wingrow.io</p>
          </div>
          <p>We will make reasonable efforts to respond to your inquiry within 2 business days.</p>
        </div>
      </section>

      <div className="bg-blue-50 border border-blue-200 rounded-lg p-6 mt-8">
        <p className="font-semibold text-gray-900 mb-2">
          By continuing to use our Service, you consent to our use of cookies as described in this
          Cookies Policy.
        </p>
        <p className="text-gray-700 text-sm">Last updated: December 27, 2025</p>
      </div>
    </>
  );
};
